import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, MailIcon, MessageSquareIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { businesses } from '../data/businesses';
export function ContactPage() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    restaurant: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formState);
    alert('Thank you for your message. We will get back to you shortly.');
    setFormState({
      name: '',
      email: '',
      phone: '',
      restaurant: '',
      message: ''
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <main className="min-h-screen bg-white" data-id="element-546">
      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[400px] w-full overflow-hidden bg-black flex items-center justify-center" data-id="element-547">
        <div className="absolute inset-0 z-0" data-id="element-548">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-60" style={{
          backgroundImage: "url('https://images.pexels.com/photos/3355402/pexels-photo-3355402.jpeg?auto=compress&cs=tinysrgb&w=1600')"
        }} data-id="element-549" />
          <div className="absolute inset-0 bg-black/50" data-id="element-550" />
        </div>

        <div className="relative z-10 text-center px-6" data-id="element-551">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-552">
            <span className="text-[#c9a961] text-[15px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-553">
              Connect With Us
            </span>
            <h1 className="font-display text-white text-[56px] md:text-[72px] font-medium leading-tight mb-6" data-id="element-554">
              Get in Touch
            </h1>
            <div className="w-24 h-[1px] bg-[#c9a961] mx-auto" data-id="element-555" />
          </motion.div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-24 px-6" data-id="element-556">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-557">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-558">
            <h2 className="font-display text-[32px] text-[#1d1d1f] mb-8" data-id="element-559">
              Send us a Message
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-560">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-561">
                <div className="space-y-2" data-id="element-562">
                  <label htmlFor="name" className="text-[13px] uppercase tracking-wider text-[#86868b] font-medium" data-id="element-563">
                    Name
                  </label>
                  <input type="text" id="name" name="name" value={formState.name} onChange={handleChange} required className="w-full px-4 py-3 bg-[#f2f2f4] border border-[#e5e5e5] focus:border-[#c9a961] focus:outline-none transition-colors rounded-sm" placeholder="Your Name" data-id="element-564" />
                </div>
                <div className="space-y-2" data-id="element-565">
                  <label htmlFor="email" className="text-[13px] uppercase tracking-wider text-[#86868b] font-medium" data-id="element-566">
                    Email
                  </label>
                  <input type="email" id="email" name="email" value={formState.email} onChange={handleChange} required className="w-full px-4 py-3 bg-[#f2f2f4] border border-[#e5e5e5] focus:border-[#c9a961] focus:outline-none transition-colors rounded-sm" placeholder="your@email.com" data-id="element-567" />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6" data-id="element-568">
                <div className="space-y-2" data-id="element-569">
                  <label htmlFor="phone" className="text-[13px] uppercase tracking-wider text-[#86868b] font-medium" data-id="element-570">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" value={formState.phone} onChange={handleChange} className="w-full px-4 py-3 bg-[#f2f2f4] border border-[#e5e5e5] focus:border-[#c9a961] focus:outline-none transition-colors rounded-sm" placeholder="+66 XX XXX XXXX" data-id="element-571" />
                </div>
                <div className="space-y-2" data-id="element-572">
                  <label htmlFor="restaurant" className="text-[13px] uppercase tracking-wider text-[#86868b] font-medium" data-id="element-573">
                    Interest
                  </label>
                  <select id="restaurant" name="restaurant" value={formState.restaurant} onChange={handleChange} className="w-full px-4 py-3 bg-[#f2f2f4] border border-[#e5e5e5] focus:border-[#c9a961] focus:outline-none transition-colors rounded-sm appearance-none" data-id="element-574">
                    <option value="" data-id="element-575">General Inquiry</option>
                    {businesses.map(b => <option key={b.slug} value={b.name} data-id="element-576">
                        {b.name}
                      </option>)}
                  </select>
                </div>
              </div>

              <div className="space-y-2" data-id="element-577">
                <label htmlFor="message" className="text-[13px] uppercase tracking-wider text-[#86868b] font-medium" data-id="element-578">
                  Message
                </label>
                <textarea id="message" name="message" value={formState.message} onChange={handleChange} required rows={6} className="w-full px-4 py-3 bg-[#f2f2f4] border border-[#e5e5e5] focus:border-[#c9a961] focus:outline-none transition-colors rounded-sm resize-none" placeholder="How can we assist you?" data-id="element-579" />
              </div>

              <button type="submit" className="px-10 py-4 bg-[#c9a961] text-black font-medium text-[14px] uppercase tracking-wide hover:bg-[#d4b872] transition-colors duration-300 rounded-sm w-full md:w-auto" data-id="element-580">
                Send Message
              </button>
            </form>
          </motion.div>

          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-12" data-id="element-581">
            <div data-id="element-582">
              <h2 className="font-display text-[32px] text-[#1d1d1f] mb-8" data-id="element-583">
                Contact Information
              </h2>
              <div className="space-y-8" data-id="element-584">
                <div className="flex items-start gap-6" data-id="element-585">
                  <div className="w-12 h-12 rounded-full bg-[#f2f2f4] border border-[#e5e5e5] flex items-center justify-center shrink-0 text-[#c9a961]" data-id="element-586">
                    <MapPinIcon className="w-6 h-6" data-id="element-587" />
                  </div>
                  <div data-id="element-588">
                    <h3 className="font-display text-[20px] text-[#1d1d1f] mb-2" data-id="element-589">
                      Head Office
                    </h3>
                    <p className="text-[#86868b] leading-relaxed font-light" data-id="element-590">
                      629, Phetchburi 31 Road, Makassan,
                      <br data-id="element-591" />
                      Ratchathewi, Bangkok 10400
                      <br data-id="element-592" />
                      Thailand
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-593">
                  <div className="w-12 h-12 rounded-full bg-[#f2f2f4] border border-[#e5e5e5] flex items-center justify-center shrink-0 text-[#c9a961]" data-id="element-594">
                    <PhoneIcon className="w-6 h-6" data-id="element-595" />
                  </div>
                  <div data-id="element-596">
                    <h3 className="font-display text-[20px] text-[#1d1d1f] mb-2" data-id="element-597">
                      Phone & WhatsApp
                    </h3>
                    <p className="text-[#86868b] leading-relaxed font-light mb-4" data-id="element-598">
                      Available daily from 9:00 AM - 6:00 PM
                    </p>
                    <a href="https://wa.me/66811770305" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#c9a961] font-medium hover:underline" data-id="element-599">
                      +66 811 770 0305
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-600">
                  <div className="w-12 h-12 rounded-full bg-[#f2f2f4] border border-[#e5e5e5] flex items-center justify-center shrink-0 text-[#c9a961]" data-id="element-601">
                    <MailIcon className="w-6 h-6" data-id="element-602" />
                  </div>
                  <div data-id="element-603">
                    <h3 className="font-display text-[20px] text-[#1d1d1f] mb-2" data-id="element-604">
                      Email Us
                    </h3>
                    <p className="text-[#86868b] leading-relaxed font-light mb-4" data-id="element-605">
                      For general inquiries and reservations
                    </p>
                    <a href="mailto:bvgroupthailand@gmail.com" className="text-[#c9a961] font-medium hover:underline" data-id="element-606">
                      bvgroupthailand@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Direct Chat Buttons */}
            <div className="p-8 bg-[#f2f2f4] border border-[#e5e5e5] rounded-sm" data-id="element-607">
              <h3 className="font-display text-[24px] text-[#1d1d1f] mb-6" data-id="element-608">
                Quick Chat
              </h3>
              <div className="grid sm:grid-cols-2 gap-4" data-id="element-609">
                <a href="https://wa.me/66811770305" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 px-6 py-4 bg-[#25D366] text-white rounded-sm hover:bg-[#20bd5a] transition-colors" data-id="element-610">
                  <MessageSquareIcon className="w-5 h-5" data-id="element-611" />
                  <span className="font-medium" data-id="element-612">WhatsApp</span>
                </a>
                <a href="#" className="flex items-center justify-center gap-3 px-6 py-4 bg-[#00B900] text-white rounded-sm hover:bg-[#00a000] transition-colors" data-id="element-613">
                  <MessageSquareIcon className="w-5 h-5" data-id="element-614" />
                  <span className="font-medium" data-id="element-615">LINE</span>
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Map Placeholder */}
      <section className="h-[400px] bg-[#f0f0f0] relative" data-id="element-616">
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-617">
          <div className="text-center" data-id="element-618">
            <MapPinIcon className="w-12 h-12 text-[#c9a961] mx-auto mb-4" data-id="element-619" />
            <p className="text-[#86868b] font-medium uppercase tracking-widest" data-id="element-620">
              Interactive Map Loading...
            </p>
          </div>
        </div>
        {/* In a real implementation, Google Maps iframe would go here */}
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.667799797076!2d100.53942831483036!3d13.753333990346386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29ec60387569d%3A0x603126743936660!2s629%20Phetchaburi%20Rd%2C%20Khwaeng%20Makkasan%2C%20Khet%20Ratchathewi%2C%20Krung%20Thep%20Maha%20Nakhon%2010400%2C%20Thailand!5e0!3m2!1sen!2sus!4v1645564821000!5m2!1sen!2sus" width="100%" height="100%" style={{
        border: 0,
        filter: 'grayscale(100%) contrast(1.2) opacity(0.8)'
      }} allowFullScreen loading="lazy" title="BV Group Location" data-id="element-621" />
      </section>

      <Footer data-id="element-622" />
    </main>;
}